import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";
import config from "../config";


import logger from "../utils/logger";
const debug = config.runmode.debug;

const downloadReport = async (
  type,
  dateFrom,
  dateTo,
  accessToken,
  afterDownloadCallback = null
) => {
  try {
    if (debug) {
      logger.log(
        `Pobieranie raportu typu [${type}] dla zakresu dat ${dateFrom} - ${dateTo}`
      );
    }

    const endpoint =
      type === "extended" ? "/reports/extended" : "/reports/basic";

    const response = await axios.get(ApiHost + endpoint, {
      params: { from: dateFrom, to: dateTo },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: "blob",
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      const disposition = response.headers["Content-Disposition"];
      const safeFrom = dateFrom.replace(/-/g, "");
      const safeTo = dateTo.replace(/-/g, "");

      let filename = `raport-eCO_${
        type === "basic" ? "podstawowy" : "rozszerzony"
      }-${safeFrom}-${safeTo}.xlsx`;
      if (disposition && disposition.includes("filename=")) {
        const matches = disposition.match(/filename="?([^"]+)"?/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      afterDownloadCallback?.();

      if (debug) logger.log("Raport pobrany:", filename);
    }
  } catch (error) {
    logger.error("Błąd podczas pobierania raportu:", error);
    afterDownloadCallback?.();
  }
};

const downloadDeferredReport = async (
  dateFrom,
  dateTo,
  accessToken,
  afterDownloadCallback = null
) => {
  try {
    if (debug) {
      logger.log(
        `Pobieranie raportu odroczonych należności dla zakresu dat ${dateFrom} - ${dateTo}`
      );
    }

    const response = await axios.get(ApiHost + "/reports/deferred", {
      params: { from: dateFrom, to: dateTo },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: "blob",
    });

    if (response.status === 200) {
      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      const disposition = response.headers["Content-Disposition"];
      const safeFrom = dateFrom.replace(/-/g, "");
      const safeTo = dateTo.replace(/-/g, "");

      let filename = `raport-eCO_odroczone-${safeFrom}-${safeTo}.xlsx`;
      if (disposition && disposition.includes("filename=")) {
        const matches = disposition.match(/filename="?([^"]+)"?/);
        if (matches && matches[1]) {
          filename = matches[1];
        }
      }

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      afterDownloadCallback?.();

      if (debug)
        logger.log("Raport odroczonych należności pobrany:", filename);
    }
  } catch (error) {
    logger.error(
      "Błąd podczas pobierania raportu odroczonych należności:",
      error
    );
    afterDownloadCallback?.();

    if (error.response && error.response.status === 500) {
      alert(
        "Wystąpił błąd podczas generowania raportu. Spróbuj ponownie lub skontaktuj się z administratorem."
      );
    } else {
      alert("Wystąpił błąd podczas pobierania raportu odroczonych należności.");
    }
  }
};

export { downloadReport, downloadDeferredReport };


